export default __webpack_public_path__ + "static/media/error404.16b386b0.svg";